import React from "react";
import { AuthConsumer } from "./authProvider";

const logoutClient = () => {
    return (
        <AuthConsumer>
            {({ logoutClient }) => {
                logoutClient();
            }}
        </AuthConsumer>
    );
};

export default logoutClient;
